import React from 'react';
import PropTypes from 'prop-types';
import LocationCardFulfillmentMethod from 'bento-ordering/locations/components/LocationCardFulfillmentMethod';
import { fulfillmentOptions } from 'bento-ordering/cart/constants/fulfillmentOptions';
import LocationCardFulfillmentTypeGridItem from 'bento-ordering/locations/ui_components/LocationCardFulfillmentTypeGridItem';
import Typography from '@material-ui/core/Typography';
import { getFormattedDayOfWeek } from 'bento-ordering/base/utils/dates';

export const NOT_ACCEPTING_ORDERS_INFORMATION_TEXT =
  'No pickup or delivery is offered for this location';

/**
 * Renders available fulfillment options(CTA) and availability for online ordering.
 *
 * @param isClosed
 * @param isAcceptingDeliveryOrders
 * @param isAcceptingPickupOrders
 * @param isAsapDeliveryCurrentlyAvailable
 * @param isAsapPickupCurrentlyAvailable
 * @param beginOrder
 * @param id
 * @param firstAvailablePickupDateOption
 * @param openDisplayDeliveryHours
 * @param firstAvailableDeliveryDateOption
 * @param doesDeliverToAddress
 * @param openDisplayPickupHours
 * @returns {*}
 */
const LocationCardOnlineOrderingFulfillmentMethods = ({
  isClosed,
  isAcceptingDeliveryOrders,
  isAcceptingPickupOrders,
  isAsapDeliveryCurrentlyAvailable,
  isAsapPickupCurrentlyAvailable,
  beginOrder,
  id,
  firstAvailablePickupDateOption,
  openDisplayDeliveryHours,
  firstAvailableDeliveryDateOption,
  doesDeliverToAddress,
  openDisplayPickupHours
}) => (
  <React.Fragment>
    {!isClosed && isAcceptingDeliveryOrders && (
      <LocationCardFulfillmentMethod
        isFullWidth
        buttonLabel={
          isAsapDeliveryCurrentlyAvailable ? 'Delivery' : 'Delivery Later'
        }
        handleButtonClick={() => beginOrder(fulfillmentOptions.DELIVERY)}
        disableButton={!doesDeliverToAddress}
        hoursLabel={
          isAsapDeliveryCurrentlyAvailable
            ? "Today's Delivery Hours"
            : `Next Delivery ${getFormattedDayOfWeek(
                firstAvailableDeliveryDateOption
              )}`
        }
        hours={openDisplayDeliveryHours}
        hoursType={fulfillmentOptions.DELIVERY}
        buttonDataTestId={`location-${id}-delivery-button`}
        hoursDataTestId={`location-${id}-delivery-hours`}
      />
    )}

    {!isClosed && isAcceptingPickupOrders && (
      <LocationCardFulfillmentMethod
        isFullWidth
        buttonLabel={isAsapPickupCurrentlyAvailable ? 'Pickup' : 'Pickup Later'}
        hoursLabel={
          isAsapPickupCurrentlyAvailable
            ? "Today's Pickup Hours"
            : `Next Pickup ${getFormattedDayOfWeek(
                firstAvailablePickupDateOption
              )}`
        }
        handleButtonClick={() => beginOrder(fulfillmentOptions.PICKUP)}
        hours={openDisplayPickupHours}
        hoursType={fulfillmentOptions.PICKUP}
        buttonDataTestId={`location-${id}-pickup-button`}
        hoursDataTestId={`location-${id}-pickup-hours`}
      />
    )}

    {isClosed && (
      <LocationCardFulfillmentTypeGridItem>
        <Typography>{NOT_ACCEPTING_ORDERS_INFORMATION_TEXT}</Typography>
      </LocationCardFulfillmentTypeGridItem>
    )}
  </React.Fragment>
);

LocationCardOnlineOrderingFulfillmentMethods.propTypes = {
  beginOrder: PropTypes.func.isRequired,
  doesDeliverToAddress: PropTypes.bool,
  firstAvailablePickupDateOption: PropTypes.string,
  firstAvailableDeliveryDateOption: PropTypes.string,
  id: PropTypes.number.isRequired,
  isAcceptingDeliveryOrders: PropTypes.bool,
  isAcceptingPickupOrders: PropTypes.bool,
  isAsapDeliveryCurrentlyAvailable: PropTypes.bool,
  isAsapPickupCurrentlyAvailable: PropTypes.bool,
  isClosed: PropTypes.bool,
  openDisplayDeliveryHours: PropTypes.string.isRequired,
  openDisplayPickupHours: PropTypes.bool.isRequired
};

LocationCardOnlineOrderingFulfillmentMethods.defaultProps = {
  doesDeliverToAddress: true,
  firstAvailablePickupDateOption: '',
  firstAvailableDeliveryDateOption: '',
  isAcceptingPickupOrders: true,
  isAcceptingDeliveryOrders: true,
  isAsapDeliveryCurrentlyAvailable: true,
  isAsapPickupCurrentlyAvailable: true,
  isClosed: false
};

export default LocationCardOnlineOrderingFulfillmentMethods;
